// Settings → Enrichments (read-only roster of admin-configured sources).

import { useAppData } from "../store";
import { Tag } from "../components/Primitives";

const STATUS_META: Record<string, [string, string]> = {
  active:         ["Active",         "var(--pos)"],
  inferred:       ["AI-inferred",    "var(--ink-3)"],
  errored:        ["Errored",        "var(--neg)"],
  not_configured: ["Not configured", "var(--ink-4)"],
};

export function EnrichmentsScreen() {
  const { data } = useAppData();
  const items = data?.config.enrichments ?? [];
  return (
    <div className="page">
      <div className="topbar">
        <span className="crumb">Settings</span>
        <span className="crumb-sep">/</span>
        <h1>Enrichments</h1>
        <span className="crumb">· read-only — configured by Prism admin</span>
      </div>
      <div className="scroll" style={{ padding: "22px 28px 60px" }}>
        <p style={{
          color: "var(--ink-2)", fontSize: 13,
          maxWidth: 540, margin: "0 0 22px",
        }}>
          Third-party sources that augment extracted fields. You can toggle each
          on or off per route in the Route editor.
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          {items.map((e: any) => {
            const [label, color] = STATUS_META[e.status] ?? ["Unknown", "var(--ink-4)"];
            return (
              <div key={e.id ?? e.name} style={{
                padding: 16, background: "var(--surface)",
                border: "1px solid var(--border)", borderRadius: 8,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>{e.name}</span>
                  <span style={{ flex: 1 }} />
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 5,
                    fontSize: 11.5, color,
                  }}>
                    <i style={{
                      width: 6, height: 6, borderRadius: 3,
                      background: color, display: "inline-block",
                    }} />
                    {label}
                  </span>
                </div>
                <div style={{
                  color: "var(--ink-2)", fontSize: 12.5,
                  marginTop: 6, minHeight: 36,
                }}>{e.desc}</div>
                <div style={{ marginTop: 12 }}>
                  <div className="eyebrow" style={{ marginBottom: 6 }}>Fields this provides</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                    {(e.fields ?? []).map((f: string) => <Tag key={f}>{f}</Tag>)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
